<template>
    <div></div>
</template>

<script>
    export default {
        name: "vLogout",
        beforeMount(){
            window.localStorage.removeItem('Name');
            window.localStorage.removeItem('role');
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('zoho_name');
            this.$router.push('login')
        }
    }
</script>

<style scoped>

</style>
